import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import NotFound from './components/NotFound';
import ForgetPassword from './components/ForgetPassword';
import Blog from './components/Blog';
import Terms from './components/Terms';
import Policy from './components/Policy';
import Store from "./components/Store";
import BlogTwo from "./components/BlogTwo";

const currentPath = window.location.pathname;
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  currentPath === "/auth/reset-password-web" ? (
    <ForgetPassword />
  ) : currentPath === "/blog/embracing-personal-care-together" ? (
    <Blog />
  ) : currentPath ===
    "/blog/5-Benefits-of-having-a-system-for-personal-care-business" ? (
    <BlogTwo />
  ) : currentPath === "/termsofuse" ? (
    <Terms />
  ) : currentPath === "/privacypolicy" ? (
    <Policy />
  ) : currentPath === "/store" ? (
    <Store />
  ) : !["/", "/thanks", "/thanksbusiness"].includes(currentPath) ? (
    <NotFound />
  ) : (
    <App />
  )
);
